<ng-container *ngIf="product">
    <div [innerHTML]="schemaMarkup"></div>
    <div class="container mt-2">
        <div class="row">
            <div class="col justicy-content-start">

                <div>
                    <a routerLink="/" class="breadcrumb">
                        Home
                    </a>
                    <!-- > -->
                    <a hidden routerLink="/" class="breadcrumb">
                        TAA/BERRY
                    </a>
                    >
                    <a class="breadcrumb"
                        style="color: black; font-size: 14px; font-family: Roboto; font-weight: 600; line-height: 30px; word-wrap: break-word">
                        {{product.title | titleWithoutColor | removeTaaBerry}}
                    </a>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="d-none d-md-flex col-md-1">
                <div class="d-flex flex-column gap-1">
                    <div [attr.active-index]="sliderIndex()" class="thumbnail"
                        *ngFor="let item of product?.media?.edges; let i = index;" [attr.data-index]="i">
                        <img (click)="changeSwiperImage(i)" [src]="item.node.image.url+'&width=150'" alt="Thumbnail"
                            class="img-fluid" [class.active]="sliderIndex() == i" />
                    </div>
                </div>
            </div>
            <div class="col col-md-7">
                <div class="row">
                    <div class="col">
                        <swiper-container #galleryTop class="gallery-top" zoom="true" navigation="true"
                            slides-per-view="1" space-between="0" loop="false" css-mode="true" thumbs="true">
                            <swiper-slide *ngFor="let item of product?.media?.edges;let i = index;">
                                <a (click)="openImageGallery(i)">
                                    <img [src]="item.node.image.url+'&width=750'" alt="image" class="img-fluid w-100"
                                        (click)="openImageGallery(i)" />
                                </a>
                            </swiper-slide>
                        </swiper-container>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="row">
                    <div class="mt-4 mt-md-0 col d-flex flex-row justify-content-start">
                        <div class="collection-toggle d-inline-flex flex-row justify-content-start" hidden>
                            <a (click)="switchProductCompliance('TAA')"
                                [class.active]="productCompliance() === 'TAA'">TAA</a>
                            <a (click)="switchProductCompliance('BERRY')"
                                [class.active]="productCompliance() === 'BERRY'">BERRY</a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <h1 class="pt-2 text-uppercase">{{product.title | titleWithoutColor | removeTaaBerry}}</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col align-items-center d-flex flex-row justify-content-between">
                        <h2 hidden class="h4">{{product.priceRange.minVariantPrice.amount | currency:
                            product.priceRange.minVariantPrice.currency}}</h2>
                        <h3 hidden class="h5 text-uppercase">
                            STYLE: {{product.style_name.value}}
                        </h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <hr class="mt-0 opacity-100">
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <h4 class="h6 text-uppercase">
                            COLOR: {{product.title | colorWithoutTitle}}
                        </h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <app-product-swatches [product]="product" (selectedProduct)="onProductSelected($event)"
                            [preload-size]="750">
                        </app-product-swatches>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        @for (option of product.options; track $index) {
                        <div class="row">
                            <div class="col mt-3 d-flex flex-row justify-content-between align-items-center">
                                <div class="h6 text-uppercase">{{option.name}}</div>
                                @if ($index == 0) {
                                <a [routerLink]="['/','size-chart']" class="link" target="_blank"
                                    rel="noopener noreferrer">
                                    <div class="h6 d-flex justify-content-end">
                                        SIZE GUIDE
                                    </div>
                                </a>
                                }
                            </div>
                        </div>
                        <div class="row">
                            <div class="col overflow-x-auto w-100">
                                <div class="d-flex flex-row gap-2">
                                    @for (value of option.optionValues; track $index) {
                                    <button
                                        class="btn btn-sm rounded-0 d-flex justify-content-center align-items-center p-3 py-2 option-value"
                                        [class.btn-outline-primary]="selectedOptions[option.name] != value.name"
                                        [class.btn-primary]="selectedOptions[option.name] === value.name"
                                        [class.active]="selectedOptions[option.name] === value.name"
                                        (click)="selectOption(option.name, value.name)">
                                        {{value.name | shortenSize}}
                                    </button>
                                    }
                                </div>
                            </div>
                        </div>
                        }
                        <div class="row">
                            <div class="col my-4">
                                <button [routerLink]="['/contact']" class="btn btn-primary extended contact">CONTACT FOR
                                    QUOTE</button>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <div class="accordion accordion-flush" id="product-details">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#product-description"
                                                aria-expanded="false" aria-controls="product-description">
                                                DESCRIPTION
                                            </button>
                                        </h2>
                                        <div id="product-description" class="accordion-collapse collapse"
                                            data-bs-parent="#product-details">
                                            <div class="accordion-body">
                                                <div [innerHTML]="product.descriptionHtml"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header">
                                            <button class="accordion-button collapsed" type="button"
                                                data-bs-toggle="collapse" data-bs-target="#product-features"
                                                aria-expanded="false" aria-controls="product-features">
                                                SPECIFICATIONS
                                            </button>
                                        </h2>
                                        <div id="product-features" class="accordion-collapse collapse"
                                            data-bs-parent="#product-details">
                                            <div class="accordion-body">
                                                <div [innerHTML]="product.features.value | newlineToBr"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <dialog #fullScreenImageGallery id="full-screen-gallery" class="dialog p-0">
        <a class="close" (click)="closeImageGallery()">&times;</a>
        <div class="dialog-content">
            <div class="fullscreen-images-list">
                <div class="m-0" *ngFor="let item of product?.media?.edges; let i = index;" [attr.data-index]="i">
                    <img [src]="item.node.image.url+'&width=1750'" alt="image" class="img-fluid w-100" />
                </div>
            </div>
        </div>
    </dialog>
</ng-container>